import { differenceInDays, format, formatDistance } from 'date-fns';
import { ru } from '@cp/shared/lib/date';
import { FormattingStrategy } from './formattingStrategy';

export const timeToDistance: FormattingStrategy = (lastSeen, now) => {
  const days = differenceInDays(now, lastSeen);
  if (days < 1) {
    return format(lastSeen, 'HH:mm');
  }
  return `${formatDistance(lastSeen, now, { locale: ru })} назад`;
};
